import React, { Fragment, useEffect, useState, useRef } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import "./style/taxCollections.css";
import { connect } from "react-redux";
import { Formik, Field } from "formik";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";
import SignupSchema from "./TaxCollectionFormValidations";
import { fallBackImage } from "../../../../utils/fallbackImage";
import * as dropDownActions from "../../../../actionCreators/DropDown";
import { FormInputField } from "../../../../Components/FormInputField/FormInputField";
import { FormPickerField } from "../../../../Components/FormPickerField/FormPickerField";
import {
  Button,
  Form,
  Input,
  Row,
  Col,
  DatePicker,
  Image,
  Typography,
} from "antd";

const { REACT_APP_SNG_STORAGE_SERVER_URL } = process.env;
const ProofOfDetaulsForm = ({
  data,
  isInspector,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef();
  const history = useHistory();
  const [error, setError] = React.useState(null);
  const [documents, setDocuments] = useState([]);
  const [paymentDate, setPaymentDate] = useState(
    data?.payment_date ? moment(data?.payment_date) : ""
  );



  let disable = true;
  if (!isInspector) {
    disable = true;
  } else {
    disable =
      data.status === "PAID" &&
      (data.approval_status === null || data.approval_status === "approved");
  }

  useEffect(() => {
    if (data?.documents?.length > 0) {
      let temp = [...documents];
      temp = temp.concat([...data?.documents]);
      setDocuments(temp);
    }
  }, [data]);



  return (
    <Fragment>
      <Row>
        <Col span={12}>
          <Typography className="heading">
            Tax Collection /{" "}
            <b style={{ fontSize: "24px", color: "#2196F3" }}>
              {data?.serial_number}
            </b>
          </Typography>
        </Col>
        <Col span={12}>
          <div className="approval-button-section header-buttons">
            <Button
                className="approve-tax-collection-button"
                type="default"
                onClick={()=>{
                    history.push("/tax-collection/view/" + data.id);
                }}
                >
                MOVE TO UPDATE PAYMENT
            </Button>
          </div>
        </Col>
      </Row>
      <Formik
        innerRef={formRef}
        validationSchema={SignupSchema}
        enableReinitialize={true}
        initialValues={{
          receipt_number: data?.receipt_number,
          payment_date: paymentDate,
          bank: data?.bank?.name,
          branch: data?.bank_branch?.name,
        }}
      >
        {(props) => (
          <Form
            onFinish={props.handleSubmit}
            form={form}
            onValuesChange={(val) => {
              if (val?.bank) {
                form.setFieldsValue({ ...form.getFieldsValue, branch: "" });
              }
            }}
          >
            {error && (
              <Row span={24}>
                <span style={{ color: "red" }}>{error}</span>
              </Row>
            )}
            <Row>
              <Col span={12} className="column-left">
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name="receipt_number"
                  errorMessage={props?.errors?.receipt_number}
                  labelText="Receipt No"
                  disabled={disable}
                  className="text-field"
                />
              </Col>
              <Col span={12} className="column-right">
                <Field
                  InputType={DatePicker}
                  component={FormPickerField}
                  name="payment_date"
                  placeholder=""
                  errorMessage={props?.errors?.payment_date}
                  labelText="Payment Date"
                  disabled={disable}
                  className="picker-field"
                />
              </Col>
            </Row>
            <Row>
              <Col span={12} className="column-left">
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name="bank"
                  errorMessage={props?.errors?.bank}
                  labelText="Bank"
                  disabled={disable}
                  className="text-field"
                />
              </Col>
              <Col span={12} className="column-right">
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name="branch"
                  errorMessage={props?.errors?.branch}
                  labelText="Bank Branch"
                  disabled={disable}
                  className="text-field"
                />
              </Col>
            </Row>
            <Row>Document Proof</Row>
            <Row>
              {documents &&
                documents.map((image, index) => {
                  let url = image.ph10_id
                    ? `${REACT_APP_SNG_STORAGE_SERVER_URL}${image.path}`
                    : !image?.deleted
                    ? URL?.createObjectURL(image)
                    : "";
                  return (
                    !image.deleted && (
                      <div
                        key={image.name + index}
                        className="image-parser"
                        style={{ margin: 10 }}
                      >
                        <Image
                          width={200}
                          height={200}
                          className="image"
                          src={url}
                          fallback={fallBackImage}
                        />
                        <span
                          style={{
                            position: "absolute",
                            bottom: 0,
                            width: "100%",
                            backgroundColor: "#34343438",
                            fontWeight: 600,
                            color: "white",
                            textAlign: "center",
                          }}
                        >
                          {moment(image.created_at).format("DD-MM-YYYY hh:mm")}
                        </span>
                      </div>
                    )
                  );
                })}
            </Row>
            <Row>
              {(!documents || documents.length === 0) && (
                <span
                  style={{
                    marginTop: 20,
                    marginBottom: 150,
                    fontWeight: "bold",
                  }}
                >
                  No proof attached
                </span>
              )}
            </Row>
          </Form>
        )}
      </Formik>
    </Fragment>
  );
};

const mapStateToProps = ({ dropDown: { banks, branches } }) => ({
  banks,
  branches,
});

const mapDispatchToProps = (dispatch) => ({
  getBanks: bindActionCreators(dropDownActions.getBanks, dispatch),
  getBranches: bindActionCreators(dropDownActions.getBranches, dispatch),
});

ProofOfDetaulsForm.propTypes = {
  data: PropTypes.object.isRequired,
  updateTaxCollection: PropTypes.func.isRequired,
  getBanks: PropTypes.func.isRequired,
  getBranches: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProofOfDetaulsForm);
